import React from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { usePartner } from 'Hooks';
import { Main } from 'Components/utility/Main';
import i18n from 'Utilities/i18n';
import { LogoActionBar } from '../ActionBar';
const AuthErrorPage = () => {
    const { partner } = usePartner();
    return (React.createElement(Main, null,
        React.createElement(LogoActionBar, { testID: "ErrorPage", noActionButton: true }),
        React.createElement(VStack, { padding: "$4", backgroundColor: "$surface.background", display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", zIndex: 1, style: {
                height: '100vh',
                width: '100vw',
            } },
            React.createElement(Text, { testID: "ErrorPage.errorLoading-title", marginBottom: "$2", color: "$text.100", fontWeight: "$h3.strong", fontSize: "$h3.strong" }, i18n.t('Global.modals.errorLoading.title')),
            React.createElement(Text, { testID: "ErrorPage.errorLoading-body", color: "$text.100", fontWeight: "$bodyBase.default", fontSize: "$bodyBase.default" }, i18n.t('Global.modals.errorLoading.body', { partnerName: partner.displayName })))));
};
export default AuthErrorPage;
